"use strict";

angular.module("customer")
.component("communityCarousel", {
    templateUrl: require("./community-carousel.component.html"),
    controller: CommunityCarouselController,
    controllerAs: "communityCarouselCtrl"
});

function CommunityCarouselController(
    $scope, $timeout, $element, $q, CommunityCarouselService, Language, UserService, RetailerUserInfoService
) {
    Language.initializeScope($scope, null, "locale");

    $scope.buttonEnabled = true;
    $scope.buttonPreviousDisplayed = false;
    $scope.buttonNextDisplayed = false;
    $scope.communities = [];

    var slickElement = $element.find(".slick");
    var responsiveSettings = [{
        breakpoint: 1200,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 5
        }
    }, {
        breakpoint: 996,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 560,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }];
    var slickSettings = {
        arrows: false,
        responsive: responsiveSettings,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 0
    };

    slickElement.slick(slickSettings);
    var slick = slickElement[0].slick;

    slickElement.on("setPosition", function(event, slick) {
        $timeout(updateArrows);
    });

    this.previousSlide = function() {
        slick.slickPrev();
    };

    this.nextSlide = function() {
        slick.slickNext();
    };

    function updateArrows() {
        var currentSlide = slick.slickCurrentSlide();
        $scope.buttonPreviousDisplayed = currentSlide > 0;

        var lastSlideVisible = currentSlide + slick.options.slidesToShow;
        $scope.buttonNextDisplayed = lastSlideVisible < $scope.communities.length;
    }

    function getSelectedValue() {
        if ($scope.exclusiveGroupId) {
            return {
                filter: "group",
                id: $scope.exclusiveGroupId
            };
        }
        else {
            return $scope.customerFilter ? $scope.customerFilter : {filter: "all"};
        }
    }

    function updateSelectedCommunity() {
        var selectedValue = getSelectedValue();
        $scope.selectedFilter = _.find($scope.communities, function(filter) {
            return CommunityCarouselService.isSelectedFilter(selectedValue, filter);
        });

        if (!$scope.selectedFilter) {
            $scope.selectedFilter = $scope.communities[0];
        }
    }

    function fetch(user) {
        $scope.customerFilter = RetailerUserInfoService.getSelectedHomeCommunityFilter(user);
        $scope.exclusiveGroupId = RetailerUserInfoService.getCustomerExclusiveDetails(user);
        $scope.notApprovedCorporateGroupId = RetailerUserInfoService.getCustomerNotApprovedCorporateGroupId(user);
        $scope.corporateApprovalStatus = RetailerUserInfoService.getCustomerCorporateApprovalStatus(user);


        CommunityCarouselService.fetchCommunities().then(
            function onSuccess(response) {
                if (response.data.length > 1) {
                    $scope.$emit("isCommunityCarouselPresent", true);
                    $scope.communities = response.data;

                    updateSelectedCommunity();

                    if (!$scope.exclusiveGroupId) {
                        var defaultCommunityValues = CommunityCarouselService.getDefaultCommunityValues();
                        $scope.communities[0]["image_path"] = defaultCommunityValues[0]["image_path"];
                        $scope.communities[0]["name"] = defaultCommunityValues[0]["name"];
                    }

                    angular.forEach($scope.communities, function(value) {
                        var scope = $scope.$new();
                        slick.slickAdd(CommunityCarouselService.compile(scope, value, slick));
                    });
                }
            }
        );
    }

    UserService.refreshCurrentUser().then(function(user) {
        if(user) {
            fetch(user);
        }
    });

    $scope.$on("communitySelected", function(event, communitySelected) {
        event.preventDefault();
        $scope.selectedFilter = communitySelected;
    });
}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/community-carousel/community-carousel.component.js
// module id = 840
// module chunks = 0